module.exports = __webpack_public_path__ + "img/dalou_2_2@2x.aa0ac425.png";